// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
import { UploadIdStatesEnumeration } from '../../enumerations/upload-id-states.enumeration';
// Types
import { AppContextType } from 'contexts/types/app.contexts.type';

const isReviewState = (currentState: AppContextType['currentState']): boolean =>
  currentState === AppStatesEnumeration.CHECKOUT_PENDING_REVIEW;

const getUploadIdFromCurrentState = (
  currentState: AppContextType['currentState']
): UploadIdStatesEnumeration =>
  isReviewState(currentState)
    ? UploadIdStatesEnumeration.DIFFERENT_DATA
    : UploadIdStatesEnumeration.LANDING;

export { getUploadIdFromCurrentState, isReviewState };
